var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("courseware-default-container", {
    attrs: {
      container: _vm.container,
      containerClass: "cw-container-accordion",
      canEdit: _vm.canEdit,
      isTeacher: _vm.isTeacher
    },
    on: {
      showEdit: _vm.setShowEdit,
      storeContainer: _vm.storeContainer,
      closeEdit: _vm.initCurrentData,
      sortBlocks: _vm.enableSort
    },
    scopedSlots: _vm._u([
      {
        key: "containerContent",
        fn: function fn() {
          return [
            _vm._l(_vm.currentSections, function(section, index) {
              return _c(
                "courseware-collapsible-box",
                {
                  key: index,
                  attrs: {
                    title: section.name,
                    icon: section.icon,
                    open: index === 0
                  }
                },
                [
                  !_vm.sortMode
                    ? _c(
                        "ul",
                        {
                          staticClass: "cw-container-accordion-block-list"
                        },
                        [
                          _vm._l(section.blocks, function(block) {
                            return _c(
                              "li",
                              {
                                key: block.id,
                                staticClass: "cw-block-item"
                              },
                              [
                                _c(_vm.component(block), {
                                  tag: "component",
                                  attrs: {
                                    block: block,
                                    canEdit: _vm.canEdit,
                                    isTeacher: _vm.isTeacher
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.showEditMode && _vm.canAddElements
                            ? _c(
                                "li",
                                [
                                  _c("courseware-block-adder-area", {
                                    attrs: {
                                      container: _vm.container,
                                      section: index
                                    },
                                    on: {
                                      updateContainerContent: _vm.updateContent
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sortMode && _vm.canEdit
                    ? _c(
                        "draggable",
                        _vm._b(
                          {
                            staticClass:
                              "cw-container-list-block-list cw-container-list-sort-mode",
                            class: [
                              section.blocks.length === 0
                                ? "cw-container-list-sort-mode-empty"
                                : ""
                            ],
                            attrs: {
                              tag: "ul",
                              handle: ".cw-sortable-handle"
                            },
                            on: {
                              start: function start($event) {
                                _vm.isDragging = true
                              },
                              end: function end($event) {
                                _vm.isDragging = false
                              }
                            },
                            model: {
                              value: section.blocks,
                              callback: function callback($$v) {
                                _vm.$set(section, "blocks", $$v)
                              },
                              expression: "section.blocks"
                            }
                          },
                          "draggable",
                          _vm.dragOptions,
                          false
                        ),
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: "flip-blocks",
                                tag: "div"
                              }
                            },
                            _vm._l(section.blocks, function(block) {
                              return _c(
                                "li",
                                {
                                  key: block.id,
                                  staticClass:
                                    "cw-block-item cw-block-item-sortable"
                                },
                                [
                                  _c(_vm.component(block), {
                                    tag: "component",
                                    attrs: {
                                      block: block,
                                      canEdit: _vm.canEdit,
                                      isTeacher: _vm.isTeacher
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.sortMode && _vm.canEdit
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "button accept",
                      on: {
                        click: _vm.storeSort
                      }
                    },
                    [_c("translate", [_vm._v("Sortierung speichern")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button cancel",
                      on: {
                        click: _vm.resetSort
                      }
                    },
                    [_c("translate", [_vm._v("Sortieren abbrechen")])],
                    1
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "containerEditDialog",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default cw-container-dialog-edit-form",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  }
                }
              },
              _vm._l(
                _vm.currentContainer.attributes.payload.sections.filter(
                  function(section) {
                    return !section.locked
                  }
                ),
                function(section, index) {
                  return _c(
                    "fieldset",
                    {
                      key: index
                    },
                    [
                      _c(
                        "label",
                        [
                          _c("translate", [_vm._v("Title")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: section.name,
                                expression: "section.name"
                              }
                            ],
                            attrs: {
                              type: "text"
                            },
                            domProps: {
                              value: section.name
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) {
                                  return
                                }

                                _vm.$set(section, "name", $event.target.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        [
                          _c("translate", [_vm._v("Icon")]),
                          _vm._v(" "),
                          _c("studip-select", {
                            attrs: {
                              options: _vm.icons
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "open-indicator",
                                  fn: function fn(selectAttributes) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._b(
                                          {},
                                          "span",
                                          selectAttributes,
                                          false
                                        ),
                                        [
                                          _c("studip-icon", {
                                            attrs: {
                                              shape: "arr_1down",
                                              size: "10"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "no-options",
                                  fn: function fn(_ref) {
                                    var search = _ref.search,
                                      searching = _ref.searching,
                                      loading = _ref.loading
                                    return [
                                      _c("translate", [
                                        _vm._v(
                                          "Es steht keine Auswahl zur Verfügung."
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "selected-option",
                                  fn: function fn(option) {
                                    return [
                                      _c("studip-icon", {
                                        attrs: {
                                          shape: option.label
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "vs__option-with-icon"
                                        },
                                        [_vm._v(_vm._s(option.label))]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "option",
                                  fn: function fn(option) {
                                    return [
                                      _c("studip-icon", {
                                        attrs: {
                                          shape: option.label
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "vs__option-with-icon"
                                        },
                                        [_vm._v(_vm._s(option.label))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: section.icon,
                              callback: function callback($$v) {
                                _vm.$set(section, "icon", $$v)
                              },
                              expression: "section.icon"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentContainer.attributes.payload.sections.length >
                      1
                        ? _c(
                            "label",
                            {
                              staticClass: "cw-container-section-delete"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button trash",
                                  on: {
                                    click: function click($event) {
                                      return _vm.deleteSection(index)
                                    }
                                  }
                                },
                                [_c("translate", [_vm._v("Fach löschen")])],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                }
              ),
              0
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button add",
                on: {
                  click: _vm.addSection
                }
              },
              [_c("translate", [_vm._v("Fach hinzufügen")])],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }